import {
    Component,
    EventEmitter,
    Input,
    Output
} from '@angular/core';

import { LineService } from './line.service';

const MAX_SEARCH_RESULTS = 50;

@Component({
    selector: 'stock-number-multiselect',
    template: `
<!-- Selected StockNumbers -->
<div *ngIf="model && model.length > 0">
    <table class="table table-sm table-borderless table-nonfluid">
        <tbody>
            <tr *ngFor="let item of model; let i = index;">
                <td class="icon-cell">
                    <a (click)="removeStockNumber(i)" title="Remove {{'LineShortName' | translate}}">
                        <i class="fa fa-remove remove-item"></i>
                    </a>
                </td>
                <td>
                    {{item.StockNumber}}
                </td>
            </tr>
        </tbody>
    </table>
</div>

<!-- StockNumber typeahead -->
<climb-indirect-typeahead
        [search]="searchStockNumbers"
        [resultFormatter]="stockNumberFormatter"
        placeholder="{{'LineShortName' | translate}}&hellip;"
        (selectItem)="selectStockNumber($event)"></climb-indirect-typeahead>
`,
    styles: [`
        .table {
            margin-bottom: 0.25em;
        }
    `]
})
export class StockNumberMultiselectComponent {
    @Input() model: any[];
    @Output() modelChange: EventEmitter<any> = new EventEmitter<any>();

    constructor(
        private lineService: LineService
    ) { }

    removeStockNumber(index: number) {
        if (this.model && index >= 0 && index < this.model.length) {
            this.model.splice(index, 1);
        }
        this.modelChange.emit(this.model);
    }

    searchStockNumbers = (term: string): Promise<any> => {
        return this.lineService.getLines({
            page: 1,
            size: MAX_SEARCH_RESULTS,
            sort: 'StockNumber asc',
            filter: {
                StockNumber: term
            }
        }).then((results: any) => {
            // Convert Breeze entity to simple object
            // so it can be serialized by consumers
            return results.results.map((line: any) => ({
                StockNumber: line.StockNumber
            }));
        });
    }

    stockNumberFormatter = (value: any) => {
        return value.StockNumber;
    }

    selectStockNumber(stockNumber: any) {
        if (this.model) {
            this.model.push(stockNumber);
        } else {
            this.model = [stockNumber];
        }

        this.modelChange.emit(this.model);
    }
}
